import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import {
  IPermissionGroup,
  IPermissionRole,
  IPreviewRolePermissionsRequest,
  IRoleGroups,
  IUpdateRoleGroupsRequest,
  IUpdateRolePermissionRequest
} from '../models/permission-role';
import { IUserRole } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) {}

  listRoles(request : IBaseSearchRequest){
    return this.http.get<IPermissionRole[]>(
      `${environment.baseUrl}/roles`
    )
  }

  getRoleDetails(id: string){
    return this.http.get<IPermissionRole>(
      `${environment.baseUrl}/roles/${id}`
    )
  }

  /** Returns the EFFECTIVE permissions of a security group, not just the individually granted ones. */
  getRoleWithPermissions(id: string){
    return this.http.get<IPermissionRole>(
      `${environment.baseUrl}/roles/${id}/permissions`
    )
  }

  getPermissions(){
    return this.http.get<string[]>(
      `${environment.baseUrl}/roles/permissions`
    )
  }

  getAvailablePermissions(){
    return this.http.get<string[]>(
      `${environment.baseUrl}/roles/available-permissions`
    )
  }

  /** The permission groups this tenant can choose from, already filtered by its modules. */
  getAvailablePermissionGroups(){
    return this.http.get<IPermissionGroup[]>(
      `${environment.baseUrl}/roles/permission-groups`
    )
  }

  getRoleGroups(roleId: string){
    return this.http.get<IRoleGroups>(
      `${environment.baseUrl}/roles/${roleId}/groups`
    )
  }

  updateRoleGroups(request : IUpdateRoleGroupsRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/roles/${request.roleId}/groups`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  /** Resolves a composition into its effective permissions without saving it. */
  previewPermissions(request : IPreviewRolePermissionsRequest){
    return this.http.post<string[]>(
      `${environment.baseUrl}/roles/preview-permissions`,
      request
    )
  }

  createRole(request : IPermissionRole ){
    return this.http.post<string>(
      `${environment.baseUrl}/roles`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  updateRole(request : IPermissionRole ){
    return this.http.put<string>(
      `${environment.baseUrl}/roles/${request.id}`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  updateRolesPermission(request : IUpdateRolePermissionRequest ){
    return this.http.put<string>(
      `${environment.baseUrl}/roles/${request.roleId}/permissions`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  deleteRole(id : string){
    return this.http.delete<string>(
      `${environment.baseUrl}/roles/${id}`
    )
  }
}
